<template>
  <div id="episode" class="episode-container" :key="episodeKey">
    <Participants v-show="participantsVisible" />
    <Exploration v-show="explorationVisible" />
    <PartsEpisode v-show="partsEpisodeVisible" />

    <div class="close-container">
      <div @click="$router.push({ path: '/' })" class="close" />
    </div>

    <div>
      <div class="episode-introduction">
        <h1 :style="{ color: this.episodes[episode_index].color }">
          {{ this.episodes[episode_index]["title"] }}
        </h1>
        <h2>{{ this.episodes[episode_index]["description"] }}</h2>
      </div>
      <div class="chunk-section">
        <ChunkCards @openExploration="explorationShow = true" />
      </div>
      <div id="player-responsive">
        <Player />
      </div>
    </div>
  </div>
</template>

<script>
import ChunkCards from "../components/ChunkCards.vue";
import Player from "../components/Player.vue";
import { mapState } from "vuex";
import ecchr_config from "../data/ecchr_config.json";
import Participants from "../components/Participants.vue";
import Exploration from "../views/Exploration.vue";
import PartsEpisode from "../views/PartsEpisode.vue";

import eyal from "../data/episode_transcripts/eyal.json";
import benedicte from "../data/episode_transcripts/benedicte.json";
import priya from "../data/episode_transcripts/priya.json";
import mark from "../data/episode_transcripts/mark.json";
import fred from "../data/episode_transcripts/fred.json";
import rabih from "../data/episode_transcripts/rabih.json";
import christina from "../data/episode_transcripts/christina.json";
import ixmucane from "../data/episode_transcripts/ixmucane.json";
import claudia from "../data/episode_transcripts/claudia.json";

export default {
  name: "Episode",
  components: {
    ChunkCards,
    Player,
    Participants,
    Exploration,
    PartsEpisode,
  },
  data() {
    return {
      title: "Episode",
      participants: false,
      explorationShow: false,
      episodes: ecchr_config["episode_cards"],
      chunks: [
        eyal["chunk_sequence"],
        benedicte["chunk_sequence"],
        priya["chunk_sequence"],
        fred["chunk_sequence"],
        rabih["chunk_sequence"],
        christina["chunk_sequence"],
        claudia["chunk_sequence"],
        mark["chunk_sequence"],
        ixmucane["chunk_sequence"],
      ],
      exploration_data: Array(),
      driver: Object,
    };
  },
  computed: {
    ...mapState([
      "episode_id",
      "episode_index",
      "participantsVisible",
      "explorationVisible",
      "device_mode",
      "partsEpisodeVisible",
      "entityObject",
      "episodeKey",
    ]),
    // episodeIndex() {
    //   const episode_index = this.episodes.findIndexOf(this.episode_id);
    //   return episode_index;
    // },
  },
  created() {
    const { id } = this.$route.params;
    this.$store.commit("updateEpisodeId", id);

    const neo4j = require("neo4j-driver");
    const uri = "bolt://ecchr.metasphere.xyz:7687/";
    const user = "neo4j";
    const password = "burr-query-duel-cherry";
    const driver = neo4j.driver(uri, neo4j.auth.basic(user, password));
    this.driver = driver;
  },
  updated() {
    this.$nextTick(function () {
      let app = document.getElementById("app");
      app.scrollTop;
    });
  },
  mounted() {
    this.fetchedObject();

    const controls = document.getElementById("player-responsive");
    if (this.device_mode == "mobile") {
      controls.classList.remove("player-desktop");
      controls.classList.add("player-mobile");
    } else {
      controls.classList.remove("player-mobile");
      controls.classList.add("player-desktop");
    }
  },
  watch: {
    $route(to, from) {
      if (to != from) {
        this.fetchedObject();
      }
    },
    entityObject: function (entityObject) {
      let entityIndex = entityObject.length;
      if (entityObject.length > 0) {
        let chunk =
          this.chunks[this.episode_index][entityIndex - 1].source_file;
        let chunk_div = document.getElementById(chunk + "_text");
        let text = chunk_div.innerHTML;
        this.entityMarker(chunk_div, text, entityObject[entityIndex - 1]);
      }
    },
    device_mode: function (device_mode) {
      const controls = document.getElementById("player-responsive");
      if (device_mode == "mobile") {
        controls.classList.remove("player-desktop");
      } else {
        controls.classList.add("player-desktop");
      }
    },
    explorationShow: function (exploration) {
      if (exploration == true) {
        const app = document.getElementById("app");
        app.classList.add("noscroll");
      }
    },
  },
  methods: {
    async entityQueryAll() {
      for (const chunk in this.chunks[this.episode_index]) {
        let chunkIndex = this.chunks[this.episode_index][chunk].source_file;
        await this.entityQuery(chunkIndex, this.episode_id).then((result) =>
          this.$store.commit("updateEntityObject", result)
        );
      }
    },
    async imageQueryAll() {
      for (const chunk in this.chunks[this.episode_index]) {
        let chunkIndex = this.chunks[this.episode_index][chunk].source_file;
        await this.imageQuery(chunkIndex, this.episode_id).then((result) =>
          this.$store.commit("updateImageObject", result)
        );
      }
    },
    async similarityQueryAll() {
      for (const chunk in this.chunks[this.episode_index]) {
        let chunkIndex = this.chunks[this.episode_index][chunk].source_file;
        await this.similarityQuery(chunkIndex, this.episode_id).then((result) =>
          this.$store.commit("updateSimilarityObject", result)
        );
      }
    },
    async urlpreviewQueryAll() {
      for (const chunk in this.chunks[this.episode_index]) {
        let chunkIndex = this.chunks[this.episode_index][chunk].source_file;
        await this.urlPreviewQuery(chunkIndex, this.episode_id).then((result) =>
          this.$store.commit("updateUrlPreviewObject", result)
        );
      }
    },
    async fetchedObject() {
      console.time("fetchData");
      const entity = this.entityQueryAll();
      const image = this.imageQueryAll();
      const similarity = this.similarityQueryAll();
      const urlpreview = this.urlpreviewQueryAll();
      await Promise.all([entity, image, similarity, urlpreview]);
      // await Promise.all([entity, image, similarity]);
      console.timeEnd("fetchData");
    },
    async entityQuery(chunk_source, episode_id) {
      const query = `Match (c:Chunk {name: $chunk, collection_id: $collection_id})-[r:MENTIONS]->(e:Entity)
      WHERE NOT e.text = ""
      Return e`;

      const entity_session = this.driver.session();
      let response_entities = Array();

      try {
        const result = await entity_session.run(query, {
          chunk: chunk_source,
          collection_id: episode_id,
        });
        const output = result.records;

        output.forEach((element) =>
          response_entities.push(element._fields[0].properties)
        );
      } finally {
        await entity_session.close();
      }
      response_entities = this.filterEntities(response_entities);
      return response_entities;
    },
    async imageQuery(chunkPosition) {
      const query_image = `Match (c:Chunk {name: $chunk, collection_id: $collection_id})-[ref:REFERENCES]-(r:Resource {resource_type: "image"})
        Return r`;

      const session_image = this.driver.session();
      let response_image = Array();

      try {
        const result = await session_image.run(query_image, {
          chunk: chunkPosition,
          collection_id: this.episode_id,
        });
        const output = result.records;
        output.forEach((element) =>
          response_image.push(element._fields[0].properties)
        );
      } finally {
        await session_image.close();
      }
      response_image = this.filterResources(response_image);
      return response_image;
    },
    async similarityQuery(chunkPosition) {
      const query_similarity = `Match (c:Chunk {name: $chunk, collection_id: $collection_id})-[s:SIMILARITY]-(c1:Chunk)
        Return c1`;

      const session_similarity = this.driver.session();
      let response_similarity = Array();

      try {
        const result = await session_similarity.run(query_similarity, {
          chunk: chunkPosition,
          collection_id: this.episode_id,
        });
        const output = result.records;
        output.forEach((element) =>
          response_similarity.push(element._fields[0].properties)
        );
      } finally {
        await session_similarity.close();
      }
      response_similarity = this.filterSimilarities(response_similarity);
      return response_similarity;
    },
    async urlPreviewQuery(chunkPosition) {
      const query_urlpreview = `Match (c:Chunk {name: $chunk, collection_id: $collection_id})-[ref:REFERENCES]-(r:Resource {resource_type: "url"})
        Return r`;

      const query_urlpreview_2 = `Match (c:Chunk {name: $chunk, collection_id: $collection_id})-[:MENTIONS]->(e:Entity)-[ref:REFERENCES]->(r:Resource {resource_type: "url"})
        Return r`;

      const session_urlpreview = this.driver.session();
      const session_urlpreview_2 = this.driver.session();
      let response_urlpreview = Array();

      try {
        const result = await session_urlpreview.run(query_urlpreview, {
          chunk: chunkPosition,
          collection_id: this.episode_id,
        });
        const output = result.records;

        await Promise.all(
          output.map(async (element) => {
            await this.createUrlPreview(element._fields[0].properties.url).then(
              (response) => response_urlpreview.push(response)
            );
          })
        );
      } finally {
        await session_urlpreview.close();
      }

      try {
        const result_2 = await session_urlpreview_2.run(query_urlpreview_2, {
          chunk: chunkPosition,
          collection_id: this.episode_id,
        });
        const output_2 = result_2.records;

        await Promise.all(
          output_2.map(async (element) => {
            await this.createUrlPreview(element._fields[0].properties.url).then(
              (response) => response_urlpreview.push(response)
            );
          })
        );
      } finally {
        await session_urlpreview_2.close();
      }

      // response_urlpreview = this.filterResources(response_urlpreview);
      return response_urlpreview;
    },
    async createUrlPreview(url_to_process) {
      const data = {
        url: url_to_process,
      };
      try {
        const response_urlPreviewProcessed = await fetch(
          "https://ecchr.metasphere.xyz:2342/text/extract/urlpreview",
          {
            method: "POST",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        return response_urlPreviewProcessed.json();
      } catch (e) {
        console.log(e);
      }
    },
    filterEntities(response_entity) {
      const response = Array.from(
        new Set(response_entity.map((a) => a.entity_id))
      ).map((entity_id) => {
        return response_entity.find((a) => a.entity_id === entity_id);
      });
      return response;
    },
    filterResources(response_resources) {
      let response = Array.from(
        new Set(response_resources.map((a) => a.resource_id))
      ).map((resource_id) => {
        return response_resources.find((a) => a.resource_id === resource_id);
      });
      return response;
    },
    filterSimilarities(response_similarities) {
      let response = Array.from(
        new Set(response_similarities.map((a) => a.chunk_id))
      ).map((chunk_id) => {
        return response_similarities.find((a) => a.chunk_id === chunk_id);
      });
      return response;
    },
    entityMarker(chunk_div, text, entities) {
      if (entities.length > 0) {
        let processed = text;
        for (const entity in entities) {
          let find = entities[entity].name;
          var reg = new RegExp(find, "gi");
          processed = processed.replace(
            reg,
            "<span class='inactive'>" + find + "</span>"
          );
        }
        chunk_div.innerHTML = processed;
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 28px;
}
.benedicte-savoy-title {
  color: rgb(248, 191, 45);
}
.fred-ritchin-title {
  color: rgba(36, 104, 205, 1);
}
.rabih-mroue-title {
  color: rgba(240, 87, 170, 1);
}
.christina-varvia-title {
  color: rgba(148, 181, 192, 1);
}
.claudia-jimenez-title {
  color: rgba(232, 79, 125, 1);
}
.mark-sealy-title {
  color: rgba(127, 105, 191, 1);
}
.ixmucane-aguilar-title {
  color: rgba(85, 162, 205, 1);
}

h2 {
  font-size: 22px;
}

.episode-introduction {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 3vh;
  padding-bottom: 1vh;
}

.noscroll {
  overflow: hidden;
}

.close-container {
  position: sticky;
  display: block;
  top: 20px;
  right: 20px;
}

.close-container:hover {
  cursor: pointer;
}

.close {
  position: absolute;
  right: 20px;
  align-content: right;
  width: 22px;
  height: 22px;
  opacity: 0.9;
}

.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 11px;
  content: " ";
  height: 23px;
  width: 1px;
  background-color: rgb(238, 238, 238);
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.episode-container {
  position: relative;
  width: inherit;
}

.player-desktop {
  position: sticky;
  bottom: 0;
}

.player-mobile {
  position: fixed;
  bottom: 0px;
  width: 100%;
  z-index: 2;
}
</style>
